import React from "react";
import { observer, inject } from "mobx-react";
import { EntityPageHeader } from "../../../../components/EntityPageHeader";
import { STORE_CUSTOMERS } from "../../../../constants";
import { CustomersStore, Customer } from "../../../../stores";
import { Row, Col } from "react-bootstrap";
import { NewEditCustomerForm } from "./NewEditCustomerForm";
import { RouteComponentProps } from "react-router-dom";

interface IProps {
    source: string;
    [STORE_CUSTOMERS]: CustomersStore
}

interface IState {
    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phone: string,
    email: string,
    address: string,
    comment: string
}

type Props = IProps & RouteComponentProps<{ id: string }>;



@inject(STORE_CUSTOMERS)
@observer
export class NewEditPage extends React.Component<Props, any> {
    constructor(props: Props) {
        super(props);

        this.state = {

        };
    }
    private formikSumbitEvent?: () => Promise<any> = undefined;
    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;

    saveCustomer = (
        firstName: string,
        middleName: string,
        lastName: string,
        phone: string,
        email: string,
        address: string,
        comment: string
    ) => {

        let customer = new Customer();

        customer = Object.assign({}, customer, {
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            phone: phone,
            email: email,
            address: address,
            comment: comment
        });

        this.customersStore.saveCustomer(customer, "abteka", (customer: Customer) => {
            this.setState({
                firstName: customer.firstName,
                middleName: customer.middleName,
                lastName: customer.lastName,
                email: customer.email,
                phone: customer.phone,
                address: customer.address,
                comment: customer.comment,
                id: customer.id
            })
        });
        console.log(customer);

    }

    componentDidMount() {
        const id = this.props.match.params.id || "";

        if (id.length > 0) {
            this.customersStore.loadCustomer(id, (customer: Customer) => {
                this.setState({
                    firstName: customer.firstName,
                    middleName: customer.middleName,
                    lastName: customer.lastName,
                    email: customer.email,
                    phone: customer.phone,
                    address: customer.address,
                    comment: customer.comment,
                    id: customer.id
                })
            });
        }
    }


    render() {
        return [<EntityPageHeader
            header="Контрагент"
            save={() => {
                if (this.formikSumbitEvent != undefined)
                    this.formikSumbitEvent();
            }}
            close={() => {
                this.props.history.push("/clients/customers");
            }}
            applicable={false}
            key={1}>

        </EntityPageHeader>,
        <Row key={2}>
            <Col sm={6} lg={4}>
                <NewEditCustomerForm key="2"
                    bindSubmitForm={(submit: () => Promise<any>) => {
                        this.formikSumbitEvent = submit;
                    }}
                    firstName={this.state.firstName}
                    middleName={this.state.middleName}
                    lastName={this.state.lastName}
                    email={this.state.email}
                    address={this.state.address}
                    phone={this.state.phone}
                    comment={this.state.comment}
                    id={this.state.id}
                    saveCustomer={this.saveCustomer}
                />
            </Col>
        </Row>
        ]
    }
}